import classnames from 'classnames';
import React from 'react';

import css from 'reactComponents/icons/defaultIconStyles.css';
import { IconProps } from 'reactComponents/icons/utilities/iconUtils';

export const IconBackupUse = ({
    width = '16',
    height = '16',
    className = undefined,
    ...props
}: IconProps) => {
    return (
        <svg
            width={width}
            height={height}
            xmlns="http://www.w3.org/2000/svg"
            className={classnames(css.main, className)}
            {...props}
        >
            <path
                className={css.colored}
                d="M5.66 3.79l.744 1.289c.238.413.134.919-.232 1.13a.715.715 0 0 1-.525.073l-3.896-.697a.898.898 0 0 1-.623-.446.897.897 0 0 1-.075-.763L2.397.653a.715.715 0 0 1 .325-.418c.367-.212.857-.049 1.095.363l.843 1.46a7.458 7.458 0 0 1 3.743-1.057h.193a7.475 7.475 0 0 1 3.073.701 7.565 7.565 0 0 1 3.55 3.465 7.467 7.467 0 0 1 .694 4.474 7.454 7.454 0 0 1-.694 2.192 7.54 7.54 0 0 1-3.885 3.612 7.503 7.503 0 0 1-10.059-4.929l-.002-.005a1.001 1.001 0 0 1 1.937-.508l.026.096a5.517 5.517 0 0 0 1.423 2.335c.49.48 1.07.866 1.702 1.134a5.5 5.5 0 0 0 7.067-7.511 5.558 5.558 0 0 0-2.546-2.515 5.538 5.538 0 0 0-2.24-.54C8.571 3 8.5 3 8.429 3a5.561 5.561 0 0 0-2.769.79zM7 9.003V6.485a1.001 1.001 0 0 1 2 0v1.938l1.232.711a1 1 0 0 1-1 1.732l-1.728-.998-.009-.005h-.001l-.002-.001v-.001h-.001a.987.987 0 0 1-.356-.359A.984.984 0 0 1 7 9.003z"
            />
        </svg>
    );
};
